import DropdownAction from 'components/DropdownAction';
import {FC} from 'react';
import {Size} from 'types';
import getPreferredLanguage from 'utils/locale';

import usePostSetLang from '../services';
import {languageDropdown} from './styles.module.css';

type DropdownLocaleProps = {
    classNameAction?: string;
    size?: Size;
};

const DropdownLocale: FC<DropdownLocaleProps> = ({
    classNameAction = languageDropdown,
    size = 'base',
}) => {
    const {mutateAsync} = usePostSetLang();

    const language = getPreferredLanguage();

    const languagesDropdown = [
        {label: '日本語', value: 'ja'},
        {label: 'English', value: 'en'},
    ];

    return (
        <DropdownAction
            classNameAction={classNameAction}
            hasCaret={false}
            icon="language"
            kind="tertiary"
            label={language === 'en' ? 'English' : '日本語'}
            size={size}
        >
            {languagesDropdown.map(({label, value}) => (
                <DropdownAction.Button
                    key={value}
                    onClick={() => {
                        mutateAsync({
                            language: value,
                        }).then(() => {
                            window.location.reload();
                        });
                    }}
                >
                    {label}
                </DropdownAction.Button>
            ))}
        </DropdownAction>
    );
};

export default DropdownLocale;
